import { useMemo } from 'react'

import { ProtobufAnyMessage } from '@/types'
import {
  UiAccordion,
  UiAccordionContent,
  UiAccordionItem,
  UiAccordionTrigger,
} from '@/ui/UiAccordion'
import { UiCard } from '@/ui/UiCard'

export default function ProposalPreview({
  messages,
}: {
  messages: ProtobufAnyMessage[]
}) {
  const typeUrls = useMemo(() => {
    return messages
      .map(message => String(message['@type'] ?? ''))
      .filter(Boolean)
  }, [messages])

  return (
    <UiCard className='p-5'>
      <div className='space-y-4'>
        <div className='flex flex-wrap items-center justify-between gap-2'>
          <div>
            <p className='text-foreground text-sm font-semibold'>Preview</p>
            <p className='text-muted-foreground text-xs'>
              Messages count: {messages.length}
            </p>
          </div>
        </div>

        <div className='space-y-2'>
          <p className='text-muted-foreground text-xs font-semibold'>Types</p>
          <div className='flex flex-col gap-1'>
            {typeUrls.map((typeUrl, index) => (
              <p key={`${typeUrl}-${index}`} className='font-mono text-xs'>
                {typeUrl}
              </p>
            ))}
          </div>
        </div>

        <UiAccordion type='multiple' className='w-full'>
          {messages.map((message, index) => (
            <UiAccordionItem key={index} value={`msg-${index}`}>
              <UiAccordionTrigger>Message #{index + 1}</UiAccordionTrigger>
              <UiAccordionContent>
                <pre className='bg-muted/20 overflow-auto rounded-md p-3 text-xs'>
                  {JSON.stringify(message, null, 2)}
                </pre>
              </UiAccordionContent>
            </UiAccordionItem>
          ))}
        </UiAccordion>
      </div>
    </UiCard>
  )
}
